import $ from 'jquery';
import '@fancyapps/fancybox';
import * as helpers from '../helpers';

export default function fancyboxPopups() {
    // Fix cross domain restrictions https://learn.javascript.ru/cross-window-communication
    const siteWrapper = document.querySelector('.site-wrapper');
    const domain = siteWrapper ? siteWrapper.getAttribute('data-domain') : null;

    if (domain) {
        document.domain = window.location.hostname === 'localhost' ? 'localhost' : domain;
    }

    $('[data-type="iframe"]').fancybox({
        toolbar: false,
        smallBtn: true,
        iframe: {
            preload: false,
        },
        btnTpl: {
            close: `
                        <button data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                            <svg role="img" aria-label="{{CLOSE}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>{{CLOSE}}</title>
                                <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/>
                            </svg>
                        </button>
                    `,
        },
        afterShow() {
            const iframe = document.querySelector('.fancybox-iframe');

            if (window.location !== window.parent.location) {
                const closeBtnArray = [...document.querySelectorAll('.fancybox-close-small')];

                closeBtnArray.forEach((closeBtn) => {
                    closeBtn.style.display = 'none';
                });
            }

            if (iframe) {
                iframe.onload = () => {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                    if (iframeDoc) {
                        setTimeout(() => {
                            const pager = iframeDoc.querySelector('.pager.-single');

                            if (pager) {
                                pager.parentNode.removeChild(pager);
                            }

                            // if (iframeDoc.body) {
                            //     iframeDoc.body.classList.add('-in-iframe');
                            //     const tarteaucitronIframe = iframeDoc.querySelector('.tarteaucitronAlertBigBottom');
                            //     if (tarteaucitronIframe) {
                            //         tarteaucitronIframe.style.display = 'none';
                            //     }
                            // }

                            const links = [...iframeDoc.querySelectorAll('a')];

                            links.forEach((link) => {
                                const target = link.getAttribute('target');
                                let href = link.getAttribute('href');
                                const isFancyboxGallery = 'fancybox' in link.dataset;
                                const isFancyboxIframe = 'fancybox' in link.dataset && link.dataset.type === 'iframe';

                                if (target === '_blank') {
                                    link.removeAttribute('rel');
                                    link.removeAttribute('title');
                                    link.classList.remove('link-external');
                                } else {
                                    link.setAttribute('target', '_top');
                                }

                                link.addEventListener('click', () => {
                                    if (target === '_blank'
                                        || href === ''
                                        || href === '#'
                                        || link.getAttribute('data-srcset')
                                        || (isFancyboxGallery && !isFancyboxIframe)
                                        // eslint-disable-next-line no-script-url
                                        || (href === 'javascript:;' && !isFancyboxIframe)
                                        || helpers.hasClass(link, 'no-redirect')
                                    ) {
                                        return;
                                    }

                                    if (isFancyboxIframe) {
                                        href = link.getAttribute('data-src');
                                    }

                                    window.location.href = href;
                                });
                            });
                        }, 1000);
                    }
                };
            }
        },

        afterClose(instance) {
            if (window.location !== window.parent.location) {
                const closeBtn = document.querySelector('.data-fancybox-close');
                closeBtn.style.display = 'block';
            }
        },
    });


    $('[data-map="localiser"]').fancybox({
        animationEffect: 'zoom',
        autoFocus: true,
        backFocus: true,
        trapFocus: false,
        clickOutside: 'close',
        idleTime: false,
        buttons: [
            'thumbs',
            'close',
        ],
        btnTpl: {
            close: `
                    <button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">
                        <svg role="img" aria-label="{{CLOSE}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <title>{{CLOSE}}</title>
                            <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/>
                        </svg>
                    </button>
                `,
        },
        type: 'iframe',
        afterLoad() {
            const btnClose = document.querySelector('.fancybox-button.fancybox-button--close');
            const fancyContent = document.querySelector('.fancybox-content');

            if (btnClose && fancyContent) {
                fancyContent.insertAdjacentElement('afterbegin', btnClose);
            }
        },
    });
}
